const yellow = "#FDC52C";
const blue = "#abdaff";
export const textTutorialPerson = {
  welcome: (
    <>
      Welcome, Pioneer! You've arrived at{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: blue,
          textDecoration: "underline",
        }}
      >
        Token Valley
      </span>
      — a place where strategy and efficiency turn{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: yellow,
          textDecoration: "underline",
        }}
      >
        resources
      </span>{" "}
      into real rewards. <br />
      Let's build a{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: yellow,
          textDecoration: "underline",
        }}
      >
        farm{" "}
      </span>
      and start your journey to success!
    </>
  ),

  selectBuilding: (
    <>
      Select a{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: yellow,
          textDecoration: "underline",
        }}
      >
        farm
      </span>{" "}
      to build and start growing your{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: blue,
          textDecoration: "underline",
        }}
      >
        Token Valley
      </span>
      . More buildings will be available soon—let's begin!
    </>
  ),

  collectResources: (
    <>
      Click on the{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: yellow,
          textDecoration: "underline",
        }}
      >
        resource icon
      </span>{" "}
      to collect materials and grow your{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: blue,
          textDecoration: "underline",
        }}
      >
        Token Valley
      </span>
      . Keep gathering to expand faster!
    </>
  ),

  sellResources: (
    <>
      Sell your{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: yellow,
          textDecoration: "underline",
        }}
      >
        resources
      </span>{" "}
      at the{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: blue,
          textDecoration: "underline",
        }}
      >
        Token House
      </span>{" "}
      to earn{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: yellow,
          textDecoration: "underline",
        }}
      >
        TV Coins
      </span>
      . The more you trade, the faster you grow!
    </>
  ),

  openSell: (
    <>
      Here, you can select the{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: yellow,
          textDecoration: "underline",
        }}
      >
        resources
      </span>{" "}
      you want to sell. Click the{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: blue,
          textDecoration: "underline",
        }}
      >
        sell button
      </span>{" "}
      to trade them for{" "}
      <span
        style={{
          fontWeight: "semi-bold",
          color: yellow,
          textDecoration: "underline",
        }}
      >
        TV Coins
      </span>
      !
    </>
  ),

  endMain: (
    <>
      That's great! <br />
      <br />
      Now try to build the buildings that are available to you.
    </>
  ),
};
